import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { MergeExactJob } from '@/services/api/entity-resolution-groups'

export function ResolutionMergeProgress({
  job,
  retry,
}: {
  job: { data?: MergeExactJob; isError: boolean }
  retry: () => void
}) {
  const { t } = useTranslation()
  const stats = job.data?.result ?? job.data?.progress
  return (
    <div role="status" className="space-y-2 text-sm">
      {job.data?.status === 'running' && (
        <p className="flex items-center gap-2">
          <Loader2 aria-hidden className="size-4 animate-spin" />
          {t('resolutionAssistant.progress', {
            processed: stats?.groups_processed ?? 0,
            total: stats?.groups_total ?? 0,
          })}
        </p>
      )}
      {job.data?.status === 'completed' && stats && (
        <p>
          {t('resolutionAssistant.completed', {
            groups: stats.merged_groups,
            entities: stats.merged_members,
            skipped: stats.skipped_groups,
            failed: stats.failed_groups,
          })}
        </p>
      )}
      {job.data?.status === 'failed' && (
        <p className="text-destructive">{t('resolutionAssistant.failed')}</p>
      )}
      {job.isError && (
        <div className="space-y-2">
          <p className="text-destructive">{t('resolutionAssistant.statusError')}</p>
          <Button variant="outline" size="sm" onClick={retry}>
            {t('resolutionAssistant.retryStatus')}
          </Button>
        </div>
      )}
    </div>
  )
}
